export var defaultSerialize = function (value) { return "" + value; };
/**
 * If sending multiple feature flags in an analytics event, use this function to
 * convert them to the standard, pipe-delimited format.
 */
export var formatFeatureFlags = function (featureFlagsClient, featureFlags) {
    return featureFlags
        .map(function (_a) {
        var flagName = _a.flagName, defaultValue = _a.defaultValue, _b = _a.serialize, serialize = _b === void 0 ? defaultSerialize : _b;
        var flagValue = featureFlagsClient.variation(flagName, defaultValue);
        return flagName + ":" + serialize(flagValue);
    })
        .join('|');
};
//# sourceMappingURL=formatFeatureFlags.js.map